import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {GAService} from "../../../root/ga/ga.service";
import {TranslateService} from "@ngx-translate/core";
import {MobileService} from "../../../core/mobile.service";
import {BookingService} from "../booking.service";
import {NotificationService} from "../../../root/toast/notification.service";
import {SessionService} from "../../../core/session.service";
import {CookieService} from "ngx-cookie";

@Component({
    selector: 'booking-list',
    templateUrl: './booking-list.component.html',
    providers: [GAService, BookingService, CookieService]
})
export class BookingListComponent implements OnInit {

    _list: any[];
    @Input() check: boolean;

    constructor(private router: Router, private route: ActivatedRoute, private gaService: GAService,
                private translate: TranslateService, private mobileService: MobileService,
                private bookingService: BookingService, private toast: NotificationService,
                private session:SessionService, private cookies:CookieService) {
    }

    private companyOid: number;
    offsetWidth: number = 0;
    bookingReadMap: any = {};
    companyMail = "";
    clientMail = "";
    bookingMap: Map<Number,string> = new Map();
    isDisable:boolean;
    oneTimeTooltip:boolean = true;

    get list(): any[] {
        return this._list;
    }

    @Input()
    set list(list: any[]) {
        this.fillBookingReadMap(list);
        this._list = list;
    }

    getCurrentLang() {
        return this.translate.currentLang;
    }

    ngOnInit() {
        this.offsetWidth = document.body.offsetWidth;
        this.route.params.subscribe(params => {
            this.companyOid = params['companyId'];
        });
        this.fillBookingReadMap(this._list);
    }

    sendGa(action, arg) {
        this.gaService.notify("Autos_listado_de_reservas", action, [arg]);
    }

    openCard: boolean = false;

    bookingActions(event, id, company) {
        this.openCard = !this.openCard;
        //TODO: no puedo encontrar el id del dsp-bobookingOidoking-ticket. Es mejor para la condición
        let element = event.target.id;
        if (element !=="booking-actions") {
            this.goToUrl(id, company);
            this.sendGa("Click_en_card", "Ver detalle");
        } else {
            this.sendGa("Click_opciones_card", "Click opciones");
        }
    }

    goToUrl(id, company) {
        var url = `company/${company}/booking/${id}`;
        if (this.mobileService.isMobile()) {
            window.open(url, "_self");
        } else {
            window.open(url);
        }
    }

    clickReadMark(bookingOid, mark) { // mark: llega el valor actual de la marca de leído de la reserva
        if (!!this.bookingReadMap[bookingOid] !==mark) {
            this.bookingReadMap[bookingOid] = mark;
            this.sendGa(mark ? "Reserva_Tildada_Leída" : "Reserva_Destildada_Leída", "Clicks");
            this.bookingService.markAsRead(this.companyOid, bookingOid, mark).subscribe(result => {
            }, (error => {
                this._list.find(function (el) {
                    return el.oid === bookingOid
                }).readMark = !mark;
                console.log(error);
                var data = (error._body) ? JSON.parse(error._body[0]) : error;
                this.toast.notifyErrorByCode(data);
            }));
        }
    }

    private fillBookingReadMap(list: any[]) {
        this.bookingReadMap = {};
        list.forEach(booking => this.bookingReadMap[booking.oid] = booking.readMark)
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/feature/booking/list/booking-list.component.ts